
import { defineComponent, nextTick, reactive, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  IManageQueryListReq,
  IManageQueryListListItem,
  IManageQueryListChildrenItem } from '@/api/project-service/type.d';

import { fetchSearch } from '@/api/project-service/index';
import AddDialog from '../components/add-dialog.vue';
import { HANDLE_SERVICE_TYPE_LIST } from '@/constant/project-service/index';
import { useList } from '@/hooks/use-list';
import EditDialog from '../components/single-edit.vue';
import BulkDialog from '../components/bulk-edit.vue';
import ProjectNameEditDialog from '../components/projectName-edit.vue';
import { ElTable } from 'element-plus';
import usePermissionConfig from '../hooks/use-permission-config';

export interface IManageQueryListListItemExtend extends IManageQueryListListItem{
  id: number;
  serviceId: '';
  projectName: string;
  domainName: string;
  isSelect: boolean | string;
}
export interface IManageQueryListChildrenItemExtend extends IManageQueryListChildrenItem{
  id: number;
  projectName: string;
  domainName: string;
  isSelect: boolean | string;
}
export default defineComponent({
  components: {
    AddDialog,
    EditDialog,
    BulkDialog,
    ProjectNameEditDialog },
  setup() {
    // 增加按钮权限
    const permissionConfig = usePermissionConfig();
    const tableRef = ref<InstanceType<typeof ElTable> | null>(null);
    const route = useRoute();
    const projectName = route.params.projectName as string;
    const firstLevelMenu = route.params.firstLevelMenu as string;
    const secondLevelMenu = route.params.secondLevelMenu as string;
    const serviceName = route.params.serviceName as string;
    const router = useRouter();

    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IManageQueryListListItemExtend, IManageQueryListReq>({
      request: {
        api: fetchSearch,
        params: {
          projectName: '',
          domainName: '',
          serviceType: '',
          firstLevelMenu: '',
          secondLevelMenu: '',
          serviceName: '',
          pageNum: 1,
          pageSize: 10,
        },

      },
      response: {
        handleResponseData(list) {
          console.log(tableData, 'tableData');
          return list.map((item) => {
            item.id = list.indexOf(item);
            item.projectName = item.parent.projectName;
            item.domainName = item.parent.domainName;
            item.serviceId = '';
            item.children = item.children.map((v) => {
              v.domainName = '';
              v.projectName = '';
              return v;
            });
            return item;
          });
        },
      },
    });

    // 新增项目弹框
    const handleDddServiceDialogState = reactive({
      visible: false,
    });
    const handleAddServiceDialog = () => {
      router.push({
        name: 'ProjectServiceManageProjectServiceAdd',
      });
    };

    // 根据子级获取父级数据
    const rowClick = (row:IManageQueryListChildrenItemExtend) => {
      let parentInfo = {} as IManageQueryListListItemExtend;
      tableData.value.forEach((item) => {
        if (item.children) {
          item.children.forEach((item2) => {
            if (item2 === row) {
              parentInfo = item;
            }
          });
        }
      });
      return parentInfo;
    };
    // 编辑项目弹框
    const handleEditDialogState = reactive({
      visible: false,
      editData: {} as IManageQueryListChildrenItemExtend,
    });
    const handleEditDialog = (row:IManageQueryListChildrenItemExtend) => {
      handleEditDialogState.visible = true;
      handleEditDialogState.editData = row || '';
      const parentInfo = rowClick(row);
      handleEditDialogState.editData.domainName = parentInfo.parent.domainName;
      handleEditDialogState.editData.projectName = parentInfo.parent.projectName;
    };
    // 项目名称编辑弹框
    const handleProjectNameEditDialogState = reactive({
      visible: false,
      projectNameInfo: {},
    });
    const handleProjectNameEditDialog = (row:IManageQueryListListItem) => {
      handleProjectNameEditDialogState.visible = true;
      handleProjectNameEditDialogState.projectNameInfo = row.parent;
    };

    const toggleSelection = (row: any, flag: boolean) => {
      if (row) {
        tableRef.value?.toggleRowSelection(row, flag);
      }
    };
    const setChildren = (children: IManageQueryListChildrenItem[], flag: boolean) => {
      children.forEach((v) => {
        toggleSelection(v, flag);
      });
    };
    const selectable = (row:IManageQueryListListItemExtend) => {
      if (row.children && row.children.length === 0) {
        return false;
      }
      return true;
    };

    const handleSelectAll = (selections: any[]) => {
      const isSelect = selections.some((item) => {
        const tableDataIds = tableData.value.map(v => v.projectName);
        return tableDataIds.includes(item.projectName);
      });
      const isCancel = !tableData.value.every((item) => {
        const selectIds = selections.map(v => v.projectName);
        return selectIds.includes(item.projectName);
      });
      console.log(isSelect, isCancel);
      if (isSelect) {
        selections.forEach((item) => {
          if (item.children && item.children.length > 0) {
            setChildren(item.children, true);
          }
        });
        return;
      }
      if (isCancel) {
        tableData.value.forEach((item) => {
          if (item.children && item.children.length > 0) {
            setChildren(item.children, false);
          }
        });
      }
    };
    // 多选 选择的行有两种数据类型故用any
    // 多选Ids
    const checkList = ref<IManageQueryListChildrenItem[]>([]);
    const handleSelectionChange = (selection:any[]) => {
      // console.log(selection, 'selection');
      checkList.value = [];
      selection.forEach((item: any) => {
        // if (item.children?.length) {
        //   // console.log('item', item);
        //   // checkList.value.push(...item.children);
        //   // checkList.value = checkList.value.concat(item);
        // } else
        if (!item.children) {
          checkList.value.push(item);
        }
      });
      checkList.value = [...checkList.value];
    };
    watchEffect(() => {
      // console.log(checkList.value.length, checkList.value, 'yayayaya');
      if (!checkList.value.length) {
        tableRef.value?.clearSelection();
      }
    });
    // 复选框点击事件
    const handleSelect = (selections: any[], row: any) => {
      console.log(row, 'row');
      const parentInfoItem = selections.map((e) => {
        return rowClick(e);
      });
      // 父级状态联动子级状态
      if (
        selections.some((item) => {
          return row.projectName === item.projectName;
        })
      ) {
        if (row.children) {
          nextTick(() => {
            setChildren(row.children, true);
            toggleSelection(row, true);
          });
        }
      } else {
        nextTick(() => {
          setChildren(row.children, false);
          toggleSelection(row, false);
        });
      }

      // 子级状态联动父级状态
      const neededParentInfoItem = Array.from(new Set(parentInfoItem)).filter(value => Object.keys(value).length !== 0);
       tableRef.value?.clearSelection();
       neededParentInfoItem.forEach((v) => {
         v.children.forEach((item) => {
           if (selections.includes(item)) {
             toggleSelection(item, true);
           }
         });
         if (v.children.every(val => selections.includes(val))) {
           //  console.log('selections', selections);
           toggleSelection(v, true);
         } else {
           toggleSelection(v, false);
           console.log('父级要变了半勾选了');
         }
       });
      // }
    };
    // 批量编辑
    const handleBulkEditDialogState = ref({
      visible: false,
      ids: [] as string[],
      serviceNames: [] as string[],
    });
    const handleBulkEditDialog = () => {
      handleBulkEditDialogState.value.ids = checkList.value.map(selection => selection.managementId);
      handleBulkEditDialogState.value.visible = true;
    };

    // // 全选
    const handleRowKey = (row: IManageQueryListListItemExtend) => {
      return row.projectName + row.id || Math.floor(Math.random() * 100000);
    };
    const handleSelectRow = (row: IManageQueryListChildrenItem) => {
      router.push({
        name: 'ProjectServiceApproveManageList',
        params: {
          serviceName: row.serviceName,

        },
      });
    };
    const init = () => {
      params.value.projectName = projectName ?? '';
      params.value.firstLevelMenu = firstLevelMenu ?? '';
      params.value.secondLevelMenu = secondLevelMenu ?? '';
      params.value.serviceName = serviceName ?? '';
      handleSearch();
    };
    const handleOperation = () => {
      handleBulkEditDialogState.value = {
        visible: false,
        ids: [] as string[],
        serviceNames: [] as string[],
      };
      checkList.value = [];
      console.log(handleEditDialogState.editData, 'handleEditDialogState.editData');
      // init();
      handleReset();
      tableRef.value?.clearSelection();
    };
    init();
    return {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleRowKey,
      handleReset,
      handleSelectRow,
      handleSizeChange,
      handleCurrentChange,
      handleAddServiceDialog,
      AddDialog,
      handleDddServiceDialogState,
      HANDLE_SERVICE_TYPE_LIST,
      handleSelectionChange,
      handleOperation,
      handleEditDialogState,
      handleEditDialog,
      handleProjectNameEditDialog,
      handleProjectNameEditDialogState,
      handleBulkEditDialogState,
      handleBulkEditDialog,
      checkList,
      tableRef,
      handleSelect,
      handleSelectAll,
      permissionConfig,
      selectable,
    };
  },

});
